import React, { FC } from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectOrganization } from "go-security/services/organizations/selectors";

interface Props {
	stockAdjustmentId: number;
}

const SubmenuStockAdjustmentPreviewNavigation: FC<Props> = ({ stockAdjustmentId }) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	return (
		<div className="content-navigation">
			{
				<Nav>
					<Nav.Item>
						<Nav.Link
							as={NavLink}
							to={`/${organization.id}/documents/stock_adjustments/${stockAdjustmentId}`}
						>
							{t("lib:common.action.preview")}
						</Nav.Link>
					</Nav.Item>
				</Nav>
			}
		</div>
	);
};

export default SubmenuStockAdjustmentPreviewNavigation;
